export const DOWNLOAD_PREVIEW_DIMENSION = 40;
export const TIMELINE_PREVIEW_DIMENSION = 40;
export const MOBILE_PAGE_SELECTION_PREVIEW_DIMENSION = 400;
